exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-37dee082] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.navbar-container[data-v-37dee082] {\n  position: fixed;\n  width: 100vw;\n  z-index: 100;\n}\n.loader-wrapper[data-v-37dee082] {\n  margin-top: 80px;\n}\n.section-wrapper[data-v-37dee082] {\n  margin-top: 80px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n@media (max-width: 768px) {\n.section-wrapper[data-v-37dee082] {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n}\n", ""]);

// exports
